$shm_wordstat_table $mol_view
	table null
	sub /
		<= Grid $mol_grid
			records <= records *
			col_ids <= col_ids /
			col_head_content* <= col_head_content* /
			cell_content* <= cell_content* /
			cell_content_text* <= cell_content* /
			Cell* <= Cell*
			Col_head* <= Col_head*
	Cell* $mol_grid_cell
		sub <= cell_content* /
		style *
			^
			width <= cell_width* \160px
			minWidth <= cell_width* \160px
			maxWidth <= cell_width* \160px
	Col_head* $mol_float
		sub <= col_head_content* /
		style *
			^
			width <= col_width* \160px
			minWidth <= col_width* \160px
			maxWidth <= col_width* \160px
	Cell_link* $mol_link
		external true
		uri <= cell_link_uri* \
		sub / \Открыть
